import * as angular from "angular";
import {IController} from "angular";

export class OmsOrderSmsMessagesViewComponent implements IController {

  orderId: any;
  isScrollable: boolean;

  public loadLimit: any;
  public omsOrderMessagesRef: any;
  public infiniteScroll: any;

  constructor(private $omsOrdersMessages, private $infiniteScroll) {
  }

  $onInit() {
    this.loadLimit = 50;
    this.omsOrderMessagesRef = this.$omsOrdersMessages();

    this.omsOrderMessagesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.omsOrderMessagesRef, this.loadLimit, {getFullData: true});
  }

  _getQueryPayload() {
    return {
      limit: this.loadLimit,
      orderId: this.orderId,
    }
  }

}

angular
  .module('bringoz.admin.messages')
  .component('omsOrderSmsMessagesView', {
    bindings: {
      orderId: '<',
      isScrollable: '<?'
    },
    template: require('./oms-order-sms-messages-view.html').default,
    controller: OmsOrderSmsMessagesViewComponent,
  });
